import React from "react";
var __jsx = React.createElement;
import { InfoScreen } from "@/pages/checkout/bnpl/common/components/InfoScreen";
import { useTranslation } from "@i18n";
import useBoolean from "@hooks/useBoolean";
import { useDhamenContext } from "@/common/Contexts/DhamenContextProvider";
import useHelpers from "@hooks/useHelpers";
import ContactModal from "@/pages/checkout/dhamen/components/common/ContactModal";
import WarningIcon from "@/pages/checkout/dhamen/icons/WarningIcon";
function OfferRejectedByUser() {
  var _state$orderInfo$orde, _state$orderInfo$orde2;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var contactModal = useBoolean();
  var _useDhamenContext = useDhamenContext(),
    state = _useDhamenContext.state;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InfoScreen, {
    icon: /*#__PURE__*/React.createElement(WarningIcon, null),
    title: tShort("dhamen/rejected_by_user_title"),
    text: tShort("dhamen/rejected_by_user_text"),
    primaryButton: {
      label: tShort("dhamen/contact_request_manager"),
      onClick: contactModal.setTrue
    },
    secondaryButton: {
      label: tShort("dhamen/back_to_home"),
      onClick: function onClick() {
        return navigateTo("/");
      }
    }
  }), /*#__PURE__*/React.createElement(ContactModal, {
    open: contactModal.value,
    onClose: contactModal.setFalse,
    toggle: contactModal.toggle,
    title: tShort("dhamen/contact_us_via"),
    phoneNumber: state === null || state === void 0 ? void 0 : (_state$orderInfo$orde = state.orderInfo.order) === null || _state$orderInfo$orde === void 0 ? void 0 : (_state$orderInfo$orde2 = _state$orderInfo$orde.sales_user) === null || _state$orderInfo$orde2 === void 0 ? void 0 : _state$orderInfo$orde2.phone_number
  }));
}
export default OfferRejectedByUser;